import { Link } from 'react-router-dom';
import { HistoryIcons } from './OrderHistoryStyled';
import { Flex } from '../../../../GlobalComponents/Flex';


type OrderHistoryLayoutProps = {
	icon: JSX.Element | string;
	name: string;
	children?: React.ReactNode | undefined;
};

export const OrderHistoryItemsLayout: React.FC<
	OrderHistoryLayoutProps
> = ({ icon, name, children }) => {
	return (
		<Flex $flexDirection="row" $width="auto">
			<Link to={`/account/orders`}>
				<div title={name}>{icon}</div>
			</Link>
			<HistoryIcons>{children}</HistoryIcons>
		</Flex>
	);
};
